import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiBaseUrl from "../apiBase";

// Initialize array to hold data returned from ProjectListData function
let projectData = [];
let projectCommentCounts = new Map();

const getTextValue = (item, keys) => {
	for (const key of keys) {
		const value = item?.[key];
		if (value !== undefined && value !== null) {
			return String(value);
		}
	}
	return "";
};

const getProjectId = (project) => project?.ProjectID ?? project?.projectId;
const getProjectName = (project) =>
	getTextValue(project, ["ProjectName", "projectName"]);
const getSponsor = (project) => getTextValue(project, ["Sponsor", "sponsor"]);

const getCommentProjectId = (comment) =>
	comment?.id ??
	comment?.ID ??
	comment?.projectId ??
	comment?.ProjectID ??
	comment?.projectID ??
	comment?.dbID ??
	comment?.DbID ??
	comment?.DBID;

const normalizeId = (value) => {
	if (value === undefined || value === null) {
		return "";
	}
	return String(value).trim();
};

const getProjectCommentCount = (project) => {
	const projectId = normalizeId(getProjectId(project));
	return projectCommentCounts.get(projectId) ?? 0;
};

// Retrieve data and sort as needed.
export function ProjectListData() {
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	//This code is an alternative to the code above.  It uses async/await instead of .then. It is a little more readable, but does the same thing. For bigger projects, it is recommended to use async/await.
	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const [projectsResponse, commentsResponse] = await Promise.all([
					fetch(`${apiBaseUrl}/LRTPProject/getall`),
					fetch(`${apiBaseUrl}/TCPProjectComments`),
				]);

				if (!projectsResponse.ok || !commentsResponse.ok) {
					throw new Error(
						`Error: ${projectsResponse.statusText || commentsResponse.statusText}`,
					);
				}

				const projects = await projectsResponse.json();
				const comments = await commentsResponse.json();
				const commentsByProjectId = new Map();
				(Array.isArray(comments) ? comments : []).forEach((comment) => {
					const commentProjectId = normalizeId(getCommentProjectId(comment));
					if (!commentProjectId) {
						return;
					}
					const existingCount = commentsByProjectId.get(commentProjectId) ?? 0;
					commentsByProjectId.set(commentProjectId, existingCount + 1);
				});

				projectCommentCounts = commentsByProjectId;
				const commentedProjectIds = new Set(commentsByProjectId.keys());

				const filteredProjects = (
					Array.isArray(projects) ? projects : []
				).filter((project) =>
					commentedProjectIds.has(normalizeId(getProjectId(project))),
				);

				setData(filteredProjects);
				setLoading(false);
			} catch (error) {
				setError(error);
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	if (loading) return <h1>Loading...</h1>;
	if (error) return <pre>{JSON.stringify(error)}</pre>;
	if (!data) return null;

	const sorted = [...data].sort((a, b) =>
		getProjectName(a).localeCompare(getProjectName(b)),
	);
	projectData = sorted;

	return (
		<div>
			<ProjectList />
		</div>
	);
}

const viewClick = (projectnumber) => {
	sessionStorage.setItem("ProjectNumber", projectnumber);
};

// main Accordion component
export const ProjectList = () => {
	ProjectListData();

	return (
		<div className="container">
			<div className="wrapper">
				<div className="answer-content">
					{projectData.map((project) => (
						<div
							className="answer-listitem"
							key={getProjectId(project) ?? getProjectName(project)}
						>
							<Link
								to="/projectsummary"
								className="project-link"
								onClick={() => viewClick(getProjectId(project))}
							>
								{getProjectName(project)} ({getProjectCommentCount(project)}{" "}
								comments)
							</Link>
							{getSponsor(project)}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default ProjectList;
